import React, { useState, useEffect } from "react";
import { Modal, Button, Select } from "antd";
import axios from "axios";
import "antd/dist/antd.css";

const { Option } = Select;

export const AddUserModal = ({ version_id, token, onUpdate }) => {
  const [visible, setVisible] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      const { data } = await axios.post(
        process.env.REACT_APP_API + "/api/users/distincts/email",
        { match: {} },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setUsers(data);
    };

    if (visible) {
      fetchUsers();
    }
  }, [visible]);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    axios
      .post(
        process.env.REACT_APP_API + "/api/mobile_app/adduser",
        { version_id, user_email: selectedUser },
        {
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        console.log(response);
        onUpdate();
      })
      .catch(error => console.error(error));

    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleChange = value => {
    setSelectedUser(value);
  };

  return (
    <div>
      <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={showModal}>
        Ajouter un utilisateur
      </Button>
      <Modal title="Ajouter un utilisateur" visible={visible} onOk={handleOk} onCancel={handleCancel}>
        <Select
          showSearch
          allowClear={true}
          style={{ width: "90%" }}
          placeholder="Choisir l'utilisateur à ajouter à la version mobile"
          optionFilterProp="children"
          onChange={handleChange}
        >
          {users.map(email => (
            <Option key={email} value={email}>
              {email}
            </Option>
          ))}
        </Select>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/AddUser.modal.js